export type AccessTokenGetter = (options?: { forceRefresh?: boolean }) => Promise<string>;

let getAccessToken: AccessTokenGetter | null = null;

export function registerApiAuth(getter: AccessTokenGetter): void {
  getAccessToken = getter;
}

export function clearApiAuth(): void {
  getAccessToken = null;
}

export function getRegisteredAccessToken(): AccessTokenGetter | null {
  return getAccessToken;
}
